import React, { useState } from 'react';
import { Card, CardContent } from '../../ui/card';
import { Separator } from '../../ui/separator';
import { ChevronDown, ChevronUp } from 'lucide-react';

const formatRelativeTime = (dateValue) => {
  if (!dateValue) return 'Unknown';
  let date;
  if (typeof dateValue === 'object' && dateValue.seconds) date = new Date(dateValue.seconds * 1000);
  else date = new Date(dateValue);
  if (isNaN(date.getTime())) return 'Unknown';
  const now = new Date(); const diffMs = now - date; const diffMins = Math.floor(diffMs / 60000); const diffHours = Math.floor(diffMins / 60); const diffDays = Math.floor(diffHours / 24);
  if (diffMins < 1) return 'Just now'; if (diffMins < 60) return `${diffMins}m ago`; if (diffHours < 24) return `${diffHours}h ago`; if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};

const UserStateItem = ({ item, type }) => {
  const [expanded, setExpanded] = useState(false);

  const getSummary = () => {
    switch (type) {
      case 'payments_deposits': return `${item.currency || 'N/A'} ${item.amount ? item.amount / 100000000 : 0} - ${formatRelativeTime(item.created_at)}`;
      case 'crypto_deposits': return `${item.currency || 'N/A'} ${item.value || 0} - ${formatRelativeTime(item.created_at)}`;
      case 'free_spins_all': return `${item.title || 'Free Spin'} - ${formatRelativeTime(item.created_at)}`;
      case 'bonuses': return `${item.title || 'Bonus'} - ${item.status || 'Unknown'}`;
      case 'documents': return `${item.status || 'Unknown'} - ${item.attachment_file_name || item.filename || 'Document'}`;
      default: return formatRelativeTime(item.created_at);
    }
  };

  const getDetails = () => {
    switch (type) {
      case 'payments_deposits': const payAmount = item.amount ? item.amount / 100000000 : 0; return [
        `ID: ${item.id}`, `System: ${item.system_name || 'N/A'}`, `Status: ${item.payment_status || 'N/A'}`, `Amount: ${payAmount} ${item.currency}`,
        item.blockchain_transaction_id && `Tx: ${item.blockchain_transaction_id}`, `Created: ${new Date(item.created_at).toLocaleString()}`
      ].filter(Boolean);
      case 'crypto_deposits': return [`ID: ${item.id}`, `Currency: ${item.currency || 'N/A'}`, `Amount: ${item.value}`, `Confirmations: ${item.confirmations || 0}`, item.transaction_id && `Tx: ${item.transaction_id}`, `Created: ${new Date(item.created_at).toLocaleString()}`].filter(Boolean);
      case 'free_spins_all': return [`ID: ${item.id}`, `Total: ${item.freespins_total || 0} spins`, `Status: ${item.status || 'N/A'}`, item.valid_until && item.valid_until.seconds > 0 && `Valid until: ${new Date(item.valid_until.seconds * 1000).toLocaleString()}`, item.games?.length > 0 && `Games: ${item.games.join(', ')}`, `Created: ${new Date(item.created_at.seconds * 1000).toLocaleString()}`].filter(Boolean);
      case 'bonuses': return [`ID: ${item.id}`, `Amount: ${item.amount_cents ? item.amount_cents / 100 : 0} ${item.currency}`, `Wager: ${item.amount_wager_requirement_cents ? item.amount_wager_requirement_cents / 100 : 0} ${item.currency}`, `Status: ${item.status || 'N/A'}`, item.activated_at?.seconds && `Activated: ${new Date(item.activated_at.seconds * 1000).toLocaleString()}`, item.finished_at?.seconds && `Finished: ${new Date(item.finished_at.seconds * 1000).toLocaleString()}`, `Created: ${new Date(item.created_at.seconds * 1000).toLocaleString()}`].filter(Boolean);
      case 'documents': return [`ID: ${item.id}`, `Type: ${item.type || 'N/A'}`, `Status: ${item.status || 'N/A'}`, `File: ${item.attachment_file_name || 'N/A'}`, `Uploaded: ${new Date(item.created_at.seconds * 1000).toLocaleString()}`].filter(Boolean);
      default: return [];
    }
  };

  return (
    <Card className="mb-1">
      <div className="flex justify-between items-center p-2 cursor-pointer hover:bg-surface-2 transition-colors rounded-t-lg" onClick={() => setExpanded(!expanded)}>
        <span className="text-sm">{getSummary()}</span>
        {expanded ? <ChevronUp className="h-4 w-4 text-ink-dim" /> : <ChevronDown className="h-4 w-4 text-ink-dim" />}
      </div>
      {expanded && <><Separator /><CardContent className="pt-1.5">{getDetails().map((line, i) => <p key={i} className="text-[11px] text-ink-dim">{line}</p>)}</CardContent></>}
    </Card>
  );
};

export default UserStateItem;
